export default __webpack_public_path__ + "static/media/traffic-lights-red.c2f07d5c.png";